import axiosInstance from '../axiosInstance';
import { initializeDB } from '../config/db';
import { TERMINAL_TORQUE_TEST_STORE } from '../config/constants';

// Соединение общее, через initializeDB.
//
// Здесь был свой openDB со своим upgrade, создающим ровно один стор. Это опаснее
// обычного лишнего коннекта: выиграй этот вызов гонку за апгрейд версии — база
// поднялась бы до новой версии с одним стором вместо шести десятков. Схему
// заводит только db.jsx, тут её быть не должно.
const openDatabase = () => initializeDB();

const terminalTorqueTestService = {
  // Save to IndexedDB
  async saveToIndexedDB(data) {
    try {
      const db = await openDatabase();
      await db.put(TERMINAL_TORQUE_TEST_STORE, data);
      return true;
    } catch (error) {
      console.error('Error saving to IndexedDB:', error);
      return false;
    }
  },

  // Get from IndexedDB
  async getFromIndexedDB(uuid) {
    try {
      const db = await openDatabase();
      return await db.get(TERMINAL_TORQUE_TEST_STORE, uuid);
    } catch (error) {
      console.error('Error getting from IndexedDB:', error);
      return null;
    }
  },

  // Get all from IndexedDB
  async getAllFromIndexedDB() {
    try {
      const db = await openDatabase();
      return await db.getAll(TERMINAL_TORQUE_TEST_STORE);
    } catch (error) {
      console.error('Error getting all from IndexedDB:', error);
      return [];
    }
  },

  // Delete from IndexedDB
  async deleteFromIndexedDB(uuid) {
    try {
      const db = await openDatabase();
      await db.delete(TERMINAL_TORQUE_TEST_STORE, uuid);
      return true;
    } catch (error) {
      console.error('Error deleting from IndexedDB:', error);
      return false;
    }
  },

  // Submit to API
  async submit(data) {
    try {
      const response = await axiosInstance.post('/terminal-torque-test/submit', data);
      return response.data;
    } catch (error) {
      console.error('Error submitting terminal torque test:', error);
      throw error;
    }
  },

  // Get from API
  async get(uuid) {
    try {
      const response = await axiosInstance.get(`/terminal-torque-test/${uuid}`);
      return response.data;
    } catch (error) {
      console.error('Error getting terminal torque test:', error);
      throw error;
    }
  }
};

export default terminalTorqueTestService;
